import React, { useContext, useState } from "react";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";

import { useFormik } from "formik";
import * as Yup from "yup";
import TextField from "@material-ui/core/TextField";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";
import Button from "@material-ui/core/Button";

import LogoPNG from "./LogoPNG";

import ButtonTextLoading from "../Shared/ButtonTextLoading";

import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import TitleIcon from "@mui/icons-material/Title";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import SendIcon from "@mui/icons-material/Send";

import styles from "../../../styles.module.css"; // Import the CSS module
import { TextareaAutosize, styled } from "@material-ui/core";
import { viewportContext } from "../../../context/ViewportContext";
import { sendSupport } from "../../../service/endpoint-manager";

const Textarea = styled(TextareaAutosize)(
  ({ theme }) => `
  width: 100%;
  font-family: 'Gotham', sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 8px 12px;
  border-radius: 8px;
  // color: ;
  background: '#fff';
  border: 1px solid lightgrey;
  

  &:hover {
    border-color: black;
  }

  &:focus {
    border-color: black;
    
  }

  // firefox
  &:focus-visible {
    outline: 0;
  }
`
);

function Support() {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { screenType } = useContext(viewportContext);

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      subject: "",
      message: "",
    },

    onSubmit: async function (values, actions) {
      setIsSubmitting(true);

      const response = await sendSupport(values);
      if (response?.status === 200) {
        enqueueSnackbar(`${response?.data?.message}`, {
          variant: "success",
        });
        navigate("/");
      } else {
        enqueueSnackbar(`${response?.data?.message}`, {
          variant: "error",
        });
      }
      setIsSubmitting(false);
    },
    // validation schema for formik using yup
    validationSchema: Yup.object({
      // username must be 6-20 and is required
      name: Yup.string().required("Username is required"),
      email: Yup.string().required("Email is required"),
      subject: Yup.string().required("Subject is required"),
      message: Yup.string().required("Message is required"),
    }),
  });

  return (
    <>
      <Container component="main" style={{ margin: "0 auto" }}>
        <CssBaseline />
        <div className={styles.supportMainContainer}>
          <div className={styles.supportLeftColumn}>
            <div className={styles.logoContainerSupport}>
              <LogoPNG />
              <div>
                <div className={styles.supportTitleContainer}>
                  <ChatBubbleOutlineIcon className={styles.supportTitleIcon} />{" "}
                  <h3 className={styles.supportTitle}>Support</h3>
                </div>
                <p>The AuditSX support team will get back to you</p>
              </div>
            </div>
          </div>
          <div className={styles.rightColumn}>
            <div className={styles.containerOutline}>
              <div className={styles.supportContainer}>
                <form
                  style={{
                    height: "100%",
                  }}
                  onSubmit={formik.handleSubmit}
                  className="form"
                  noValidate
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: "column",
                      height: "100%",
                    }}
                  >
                    <div className={styles.supportFieldsDiv}>
                      <div
                        className={`${styles.inputGridSupport} ${styles.userFormFields}`}
                      >
                        <TextField
                          error={formik.touched.name && formik.errors.name}
                          required={false}
                          fullWidth
                          id="name"
                          label="Name"
                          name="name"
                          autoComplete="name"
                          type="name"
                          variant="outlined"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.name}
                          InputLabelProps={{
                            className: styles.userInputFields,
                          }}
                          InputProps={{
                            endAdornment: (
                              <PersonIcon
                                style={{ color: "rgba(126, 154, 181, 0.3)" }}
                                className={styles.userInputFieldsProps}
                              />
                            ),
                          }}
                        />
                      </div>
                      <div
                        className={`${styles.inputGridSupport} ${styles.userFormFields}`}
                      >
                        <TextField
                          error={formik.touched.email && formik.errors.email}
                          required={false}
                          fullWidth
                          name="email"
                          label="Email"
                          type="email"
                          id="email"
                          variant="outlined"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.email}
                          InputLabelProps={{
                            className: styles.userInputFields,
                          }}
                          InputProps={{
                            endAdornment: (
                              <EmailIcon
                                style={{ color: "rgba(126, 154, 181, 0.3)" }}
                                className={styles.userInputFieldsProps}
                              />
                            ),
                          }}
                        />
                      </div>
                      <div
                        className={`${styles.inputGridSupport} ${styles.userFormFields}`}
                      >
                        <TextField
                          error={
                            formik.touched.subject && formik.errors.subject
                          }
                          required={false}
                          fullWidth
                          name="subject"
                          label="Subject"
                          type="subject"
                          id="subject"
                          variant="outlined"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.subject}
                          InputLabelProps={{
                            className: styles.userInputFields,
                          }}
                          InputProps={{
                            endAdornment: (
                              <TitleIcon
                                style={{ color: "rgba(126, 154, 181, 0.3)" }}
                                className={styles.userInputFieldsProps}
                              />
                            ),
                          }}
                        />
                      </div>
                      <div
                        className={`${styles.inputGridSupport} ${styles.userFormFields}`}
                      >
                        <p className={styles.messageLabel}>Message</p>
                        <Textarea
                          style={{
                            resize: "none",
                            width: "100%",
                            padding: "10px",
                          }}
                          minRows={6}
                          maxRows={10}
                          error={
                            formik.touched.message && formik.errors.message
                          }
                          required={false}
                          name="message"
                          label="Message"
                          id="message"
                          variant="outlined"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.message}
                        />
                      </div>
                    </div>

                    <div>
                      <div className={styles.supportButtonContainer}>
                        <Button
                          fullWidth
                          variant="contained"
                          className={`${styles.supportCancelButton} ${styles.redButton}`}
                          onClick={() => navigate("/")}
                        >
                          Cancel
                        </Button>
                        <Button
                          type="submit"
                          fullWidth
                          variant="contained"
                          disabled={isSubmitting}
                          className={`${styles.supportSubmitButton} ${styles.primaryButton}`}
                          endIcon={screenType.isMobile ? <></> : <SendIcon />}
                        >
                          <ButtonTextLoading
                            isSubmitting={isSubmitting}
                            body={"Send"}
                          />
                        </Button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
}

export default Support;
